import type { ConsentSettings } from '../types';

type EventParams = Record<string, string | number | boolean>;

export const trackEvent = (
  eventName: string,
  params?: EventParams
) => {
  try {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) return;

    const settings: ConsentSettings = JSON.parse(consent);
    if (settings.analytics_storage !== 'granted') return;

    if (typeof window.gtag !== 'function') {
      console.warn('Google Tag Manager not initialized');
      return;
    }

    window.gtag('event', eventName, params);
  } catch (error) {
    console.error('Failed to track event:', error);
  }
};

export const trackError = (
  error: Error,
  componentName: string
) => {
  trackEvent('error', {
    error_message: error.message,
    error_component: componentName,
    error_stack: error.stack || 'No stack trace'
  });
};